
define('app/users/pwreset/activate/pwActApp',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/pwActModel',
	'unknown/models/pwActKeyModel',
	'unknown/views/pwActView'
], function($, _, Backbone, PwActModel, PwActKeyModel, PwActView){
	var initialize = function(){
		var resource = "activate";		
		var pathArray = window.location.pathname.split('/');
		var resourceIndex = -1;
		var actKey = null;
		for (var i = 0; i < pathArray.length; i++ ) {
			if(resourceIndex == -1 && pathArray[i] == resource){
				resourceIndex = i;
			} else if(resourceIndex != -1 && i == resourceIndex + 1){
				actKey = pathArray[i];
			}
		}
		
		var pwKeyModel = new PwActKeyModel();
		var pwResetModel = new PwActModel();
		var pwResetActView = new PwActView({pwKeyModel: pwKeyModel, pwResetModel: pwResetModel});
		pwResetActView.render();
		
		if(actKey){
			$("#pwResetActKeyInput").val(actKey);
			pwKeyModel.set("key", actKey);
			pwResetActView.processKey();
		}
	};
	
	return {
		initialize: initialize
	};
});